
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.23563 5.21808C0.549803 4.92731 1.05918 4.92731 1.37336 5.21808L10.0007 13.2025L18.6267 5.21812C18.9407 4.92733 19.4501 4.92729 19.7643 5.21803C20.0785 5.50876 20.0786 5.98019 19.7644 6.27097L10.5696 14.7819C10.4188 14.9216 10.2141 15 10.0008 15C9.78738 15 9.58274 14.9216 9.43186 14.7819L0.23563 6.27101C-0.0785433 5.98025 -0.0785433 5.50883 0.23563 5.21808Z","fill":"#8338EC"}})])
          )
        }
      }
    